import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import useStyles from './ChipComponent.styled.jsx';
import { makeStyles } from '@material-ui/core';

const useChipStyles = makeStyles(() => ({
    chip: {
        fontSize: '10px',
        height: '24px',
        padding: '4px 0',
        fontWeight: '400',
        marginRight: (props) => (props?.isFromAutoComplete ? '15px' : '0'),
    },
}));

const ChipComponent = ({
    height = '',
    label,
    isFromAutoComplete = false,
    borderRadius = '',
    color = '',
    mobilePadding = '',
    desktopPadding = '',
    mobileMargin = '',
    desktopMargin = '',
    position = '',
    padding = '',
    bottom = '',
    right = '',
    id,
    marginLeft = '',
}) => {
    const classes = useStyles();
    const chipClasses = useChipStyles({ isFromAutoComplete });

    return (
        <div className={classes.root}>
            <Chip
                className={chipClasses.chip}
                id={id}
                size="small"
                label={label}
                style={{
                    height: height || undefined,
                    borderRadius: borderRadius || undefined,
                    color: color || undefined,
                    padding: padding || undefined,
                    margin: isFromAutoComplete ? '0 15px 0 0' : undefined,
                    position: position || undefined,
                    bottom: bottom || undefined,
                    right: right || undefined,
                    marginLeft: marginLeft || undefined,
                }}
                data-mobile-padding={mobilePadding}
                data-desktop-padding={desktopPadding}
                data-mobile-margin={mobileMargin}
                data-desktop-margin={desktopMargin}
                data-is-from-autocomplete={isFromAutoComplete}
            />
        </div>
    );
};

ChipComponent.propTypes = {
    height: PropTypes.string,
    label: PropTypes.node.isRequired,
    isFromAutoComplete: PropTypes.bool,
    borderRadius: PropTypes.string,
    color: PropTypes.string,
    mobilePadding: PropTypes.string,
    desktopPadding: PropTypes.string,
    mobileMargin: PropTypes.string,
    desktopMargin: PropTypes.string,
    position: PropTypes.string,
    padding: PropTypes.string,
    bottom: PropTypes.string,
    right: PropTypes.string,
};

export default ChipComponent;
